document.addEventListener("DOMContentLoaded", function() {

    function isSafari() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('safari') && !ua.includes('chrome'); // Detect Safari (excluding Chrome on macOS)
    }

    const isUsingSafari = isSafari();

    // Letter Tabs
    let glossary = document.getElementsByClassName('documents-letter-tabs');

    function onGlossaryTab(event) {
        let thisObj = event.currentTarget;
        let letterTarget = thisObj.getAttribute('data-letter-target');

        setGlossarySelection(glossary, letterTarget);
    }

    function setGlossarySelection(glossary, selection) {

        let selectionArray = selection.split(',');

        let glossaryLetters = document.querySelectorAll('.glossary-letter');

        glossaryLetters.forEach(function(letter) {
            letter.setAttribute('hidden', true);
        });

        selectionArray.forEach(function(currentLetter) {
            let currentGlossaryLetter = document.querySelector('.glossary-letter[data-letter="' + currentLetter + '"]');
            if (currentGlossaryLetter) {
                currentGlossaryLetter.removeAttribute('hidden');
            }

            let currentButton = document.querySelector('button[data-letter-target="' + selection + '"]');
            if (currentButton) {
                currentButton.setAttribute('aria-label', 'Currently displaying products starting with ' + currentLetter + ' in list. Use arrow keys or tab to navigate the list. Click another letter button to filter by a different letter.');
            }
        });

        glossaryLetters.forEach(function(letter) {
            letter.setAttribute('hidden', true);
            if (letter.getAttribute('data-letter') === selection) {
                letter.removeAttribute('hidden');
            }
        });
    }

    let buttons = document.querySelectorAll('.letter-button');
    buttons.forEach(function(button) {
        button.addEventListener('click', onGlossaryTab);
    });

    // Fuzzy Search Query
    let searchTimeout;

    document.getElementById('searchProducts').addEventListener('input', function() {
        clearTimeout(searchTimeout);

        document.getElementById('product-search-results').innerHTML = '';

        searchTimeout = setTimeout(() => {
            let filter = this.value.toLowerCase();
            let links = document.querySelectorAll('.product-link');
            let results = '';
            let foundMatch = false;

            links.forEach(function(link) {
                let linkName = link.getAttribute('data-search').toLowerCase();

                if (filter === '') {
                    results = '';
                } else if (linkName.includes(filter)) {
                    results += '<a href="' + link.getAttribute('href') + '" class="product-link text-red no-underline hover:text-blue" data-name="' +
                        link.getAttribute('data-name') + '" data-search="' + link.getAttribute('data-search') + '" target="_blank">' +
                        '<i class="fas fa-download me-2"></i>' + link.getAttribute('data-name') + '</a>';
                    foundMatch = true;
                }
            });
            if (!foundMatch && filter !== '') {
                results = '<li class="col-span-3 text-center">No results found.</li>';
            }

            // Update results display
            document.getElementById('product-search-results').innerHTML = results;
            attachDownloadTrackingListeners();
        }, 500);  // Delay of 500ms
    });

    // Download Tracking Event Listener
    function attachDownloadTrackingListeners() {
        document.querySelectorAll('.download-tracking a.product-link').forEach(link => {
            link.addEventListener('click', async function (event) {
                event.preventDefault(); // Stop the default behavior

                const pdfName = this.getAttribute('data-name');
                const userHash = localStorage.getItem('userHash');

                if (!userHash) {
                    alert('User information not found. Please submit the form first.');
                    return; // Do not proceed if userHash is missing
                }

                try {
                    // Send tracking data to the server
                    const response = await fetch('/api/form/trackDownload', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            pdf: pdfName,
                            hmac: userHash,
                            timestamp: new Date().toISOString(),
                        }),
                    });

                    if (!response.ok) {
                        throw new Error('Tracking failed.');
                    }

                    const data = await response.json();
                    if (data.status === 'success') {
                        // Tracking succeeded, proceed with opening the PDF
                        if (isUsingSafari) { //Safari may block download popup window due to security (download is not immediately triggered by user click due to a script running before the window action). Thus, open in same window instead.
                            window.location.href = this.href;
                        }else {
                            window.open(this.href, '_blank');
                        }
                    } else {
                        throw new Error('Tracking unsuccessful.');
                    }
                } catch (error) {
                    console.error('Error tracking download:', error.message);
                    alert('Error submitting download request. Please try again later.');
                }
            });
        });
    }
    attachDownloadTrackingListeners();
});
